import { gql } from '@apollo/client'
import { format } from 'date-fns'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'

import { MOONBEAM } from '../../config/chains'
import { SUBGRAPH_URLS } from '../../config/subgraphs'
import { USD_DECIMALS } from '../const'
import { roundDownToNearestDay } from '../numbers'
import { createClient } from '../useClient'

export default function useVolumeStats(params) {
  const [volumeData, setVolumeData] = useState([])
  const client = createClient(SUBGRAPH_URLS[MOONBEAM].stats)

  useEffect(() => {
    if (!params.fromValue || !params.toValue) {
      return
    }

    const start = roundDownToNearestDay(params.fromValue)
    const end = roundDownToNearestDay(params.toValue)

    const volumeStatsQuery = gql`
      query dailyVolumeStats($start: Int!, $end: Int!) {
        volumeStats(
          first: 1000
          orderBy: id
          orderDirection: asc
          where: { period: daily, id_gte: $start, id_lte: $end }
        ) {
          id
          margin
          swap
          liquidation
          mint
          burn
        }
      }
    `

    const getVolume = async () => {
      client
        .query({
          query: volumeStatsQuery,
          variables: { start: start, end: end },
        })
        .then(({ data }) => {
          const { volumeStats } = data
          const chartData = volumeStats.map((el) => {
            const d = new Date(el.id * 1000)

            return {
              x: format(d, 'do MMM, yyyy'),
              margin: parseFloat(
                ethers.utils.formatUnits(el.margin, USD_DECIMALS)
              ),
              swap: parseFloat(ethers.utils.formatUnits(el.swap, USD_DECIMALS)),
              liquidation: parseFloat(
                ethers.utils.formatUnits(el.liquidation, USD_DECIMALS)
              ),
              mint: parseFloat(ethers.utils.formatUnits(el.mint, USD_DECIMALS)),
              burn: parseFloat(ethers.utils.formatUnits(el.burn, USD_DECIMALS)),
            }
          })

          setVolumeData(chartData)
        })
    }

    getVolume()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return volumeData
}
